import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { match } from "ts-pattern";
import { DATE_FORMATS } from "./constants";

export type FormatDateRangeOptions = {
  format?: string; // e.g. "DD-MM-YYYY"
  fallback?: string; // shown when both dates are missing or invalid
  separator?: string; // e.g. " - " or " to "
};

export type DateValue = string | Dayjs | null;

export const formatDateRange = (
  startDate?: DateValue,
  endDate?: DateValue,
  options?: FormatDateRangeOptions
): string => {
  const { format = DATE_FORMATS.display, fallback = "--", separator = " - " } = options || {};

  if (!startDate && !endDate) return fallback;

  const start = startDate ? dayjs(startDate) : null;
  const end = endDate ? dayjs(endDate) : null;

  const isStartValid = start?.isValid();
  const isEndValid = end?.isValid();

  return match<[boolean, boolean]>([isStartValid, isEndValid])
    .with([true, true], () => `${start!.format(format)}${separator}${end!.format(format)}`)
    .with([true, false], () => `${start!.format(format)}${separator}${fallback}`)
    .with([false, true], () => `${fallback}${separator}${end!.format(format)}`)
    .otherwise(() => fallback);
};
